form.search {
    margin: 0.5em 0;
    display: flex;
    max-width: 30em;
}

form.search input {
    margin: 0 0.5em;
    flex-grow: 1;
}

td.number {
    padding: 0;
    white-space: nowrap;
}

td.number a {
    /*
    make the whole cell clickable:
    - block link (for 100% width)
    - move padding from the TD cell to the link (for more width)
    - padding is less than the other TD elements, but since the text is center aligned, it'll look fine, and it counters the bigger font size
    - setting 100% height would do nothing, because the TD doesn't have a fixed height, but is dynamic based on content
    */
    display: block;
    padding: 0 .5em;
    text-align: center;
    font-size: 140%;
}

td.number:hover a {
    font-weight: bold;
}

a.sortable {
    display: grid;
    grid-template-columns: 1fr 1ex;
    gap: 1ex;
    color: inherit;

    &:hover {
        text-decoration: underline;
    }
}

.sort-icon {
    grid-row: 1;
    grid-column: 2;
    color: #aaa;

    &.active {
        color: black;
    }
}

.map {
    width: 100%;
    height: min(700px, calc(100vh - 8em));
}

.placeholder {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fafafa;
    color: #f0f0f0;
    /* 300px is for desktop, but on mobile it should be smaller to not fill the whole width/height (depending on device orientation) */
    font-size: min(300px, 60cqw, 60cqh);
}

.map-legend {
    width: 100%;
    font-size: 0.8rem;
    white-space: nowrap;
    margin-bottom: 1.5rem;

    :is(table) {
        margin: 0 auto;
    }

    :is(th) {
        text-align: left;
        font-weight: normal;
    }

    :is(td) {
        width: 1.5em;
        text-align: center;
        border: 2px solid var(--border-color);
        background-color: var(--background-color);
    }

    :is(tr).months th {
        text-align: center;
    }
}